export enum StatusParticipationEnum {
  pen = 'pen',
  pub = 'pub'
}
